module.exports = __webpack_public_path__ + "static/media/quickstart-step-7.bb8fc931.jpg";